export default function user({ next, store }) {
  const user = store.getters['credential/user']
  if (user.user.pefil === 'student') {
    // history.back()
  }
}
